type AuthAPIUrlsKeys = 'subscriptionProducts' | 'subscriptionCreate';

export const authAPIUrls: Record<AuthAPIUrlsKeys, `/${string}`> = {
  subscriptionProducts: '/subscription/products',
  subscriptionCreate: '/subscription/create',
} as const;
